import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { LocalService, Wrappers15, KeyValueSetInt, Wrapper15Initialization, Status, InteractionType, PageKey, Payment, TriggeredEvent, PrepaidDetailReason } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { CommentComponent } from '../../popups/comment/comment.component';
import { HtmlViewerComponent } from '../../popups/html-viewer/html-viewer.component';
import { PayFromWalletComponent } from '../../popups/pay-from-wallet/pay-from-wallet.component';

@Component({
  selector: 'app-my-payments',
  templateUrl: './my-payments.component.html',
  styleUrls: ['./my-payments.component.scss']
})
export class MyPaymentsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["payments"]; source: Wrapper15Initialization; IsPrint: boolean = false; printContent: string = ''; fileName: string = '';
  wrapper: Wrappers15; paymentStage: number = 1; interactionType = 0; maxBodyHeight = 0; ids?: string[];
  businessId: string; userId: string; ctryCode: string; isShowPayment: boolean = false; amountToRecharge: number = null;
  recordTypes: KeyValueSetInt[] = [{ key: 1, value: 'Pending' } as KeyValueSetInt, { key: 2, value: 'Paid' } as KeyValueSetInt, { key: 3, value: 'Waived' } as KeyValueSetInt];

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private languageManagementService: LanguageManagementService, private profileManagementService: ProfileManagementService, private modalService: NgbModal, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.userId = routeParams.userId;
      if (this.interactionType == InteractionType.Business)
        this.configurationManagementService.ensurePageActions(PageKey.MyPayments, this.businessId);
      else if (this.interactionType == InteractionType.ServiceProvider)
        this.configurationManagementService.ensurePageActions(PageKey.MyPaymentsServiceProvider);
      else if (this.interactionType == InteractionType.Bill_PnixSoft)
        this.configurationManagementService.ensurePageActions(PageKey.PaymentsAdmin);
      this.configurationManagementService.ensurePageActions(this.localService.currentPageKey);
      if (this.interactionType == InteractionType.Business && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else if (this.interactionType == InteractionType.ServiceProvider && (this.businessId == '' || this.businessId == '0')) {
        this.localService.onDirectToServiceProviderCreation();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.source = null;
        this.ctryCode = routeParams.ctryCode;
        if (this.interactionType == InteractionType.Bill_PnixSoft)
          this.onInitiate();
        else
          this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.profileManagementService.getPaymentInitialization(this.paymentStage, this.businessId).subscribe(result => {
      this.source = result;
      this.wrapper = result.content;
    });
  }

  onLoad() {
    let ctryCode = this.ctryCode == '0' ? this.source.locations.selected.key : this.ctryCode;
    this.profileManagementService.getMyPayments(this.paymentStage, this.businessId, ctryCode, this.ctryCode == '0' ? this.source.locations.selected : null, this.wrapper != undefined && this.wrapper != null ? this.wrapper.paging : null).subscribe(result => {
      this.wrapper = result;
    });
  }

  onClick(index, strComment = '') {
    let selectedItems = this.wrapper.items.filter(x => x.isSelected);
    if (selectedItems.length == 0) {
      this.localService.showMessage(this.localService.languageContent.payments.select_item);
    } else {
      let ids = selectedItems.map(x => x.key);
      let isWaiver = index == 3;
      switch (index) {
        case 1: {
          this.amountToRecharge = selectedItems.reduce((sum, current) => sum + parseFloat(current.v4), 0);
          this.ids = selectedItems.map(x => x.key);
          this.isShowPayment = true;
        } break;
        case 2:
        case 3: {
          if (strComment) {
            this.profileManagementService.savePayment(ids, isWaiver, strComment, this.getCountryCode()).subscribe(result => {
              this.localService.showInformationByStatus(result);
              if (result == Status.Success) {
                this.onLoad();
              }
            });
          } else {
            this.onOpenComment(index);
          }
        } break;
        case 4: {
          let amount = selectedItems.reduce((sum, current) => sum + parseFloat(current.v4), 0);
          if (amount > 0) {
            const modalRef = this.modalService.open(PayFromWalletComponent);
            modalRef.componentInstance.prepaidDetailReason = PrepaidDetailReason.DedcutedForMonthlyBill;
            modalRef.componentInstance.amount = amount;
            modalRef.componentInstance.ids = ids;
            modalRef.componentInstance.businessOrUserId = this.interactionType == InteractionType.User ? this.userId : this.businessId;
            modalRef.result.then((result) => {
              if (result.event == TriggeredEvent.Ok) {
                this.onLoad();
              }
            });
          } else {
            this.localService.showMessage(this.localService.languageContent.payments.select_item);
          }
        } break;
      }

    }
  }

  onOpenComment(index) {
    const modalRef = this.modalService.open(CommentComponent);
    modalRef.componentInstance.index = index;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        this.onClick(index, result.data);
      }
    });
  }

  onGenerateRent() {
    this.configurationManagementService.generateRent().subscribe(result => {
      this.localService.showMessageByStatus(result);
    });
  }

  getCountryCode() {
    let ctryCode = this.ctryCode == '0' ? this.source.locations.selected.key : this.ctryCode;
    return ctryCode;
  }

  onOpenInvoice(id, index: number) {
    this.profileManagementService.getInvoice(id, this.getCountryCode(), index != 1).subscribe(result => {
      switch (index) {
        case 1: {
          const modalRef = this.modalService.open(HtmlViewerComponent, { size: 'xl' });
          modalRef.componentInstance.content = result.value;
          modalRef.componentInstance.isPopUp = true;
        } break;
        case 2: {
          this.fileName = result.key;
          this.IsPrint = true;
          this.printContent = result.value;
        } break;
      }
    });
  }

  onPrinted() {
    this.IsPrint = false;
  }

  onPaymentProccesed(e: any) {
    this.onLoad();
  }
}
